// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3tqfb","modalForm":"UpgradeEpcsModal_modalForm__2yKue","modalFooter":"UpgradeEpcsModal_modalFooter__19uml"};